import { createAsyncThunk } from '@reduxjs/toolkit'

import { CommissionBenchmarkService } from '../api/commissionBenchmarkApi'
import {
  CommissionBenchmarkAccountBreakdownResponse,
  CommissionBenchmarkAccountOverviewResponse,
  CommissionBenchmarkBenchmarkTypeEnum,
  CommissionBenchmarkNuvestoAccountTypeEnum,
  CommissionBenchmarkReferenceResponse,
  GetCommissionBenchmarkOverviewRequest,
} from '../api/types'

export const SLICE_NAME = 'commissionBenchmark'

type ReferenceParams = {
  benchmarkType?: CommissionBenchmarkBenchmarkTypeEnum
  nuvestoAccountType?: CommissionBenchmarkNuvestoAccountTypeEnum
}

export const GetCommissionBenchmarkReference = createAsyncThunk(
  `${SLICE_NAME}/getReference`,
  async (params: ReferenceParams | undefined, thunkAPI) => {
    try {
      const res = await CommissionBenchmarkService.getReference(params)

      if (res.success) return res as CommissionBenchmarkReferenceResponse

      return thunkAPI.rejectWithValue(res.message ?? 'Failed to load benchmark reference')
    } catch (error) {
      return thunkAPI.rejectWithValue(error instanceof Error ? error.message : String(error))
    }
  },
)

export const GetCommissionBenchmarkOverview = createAsyncThunk(
  `${SLICE_NAME}/getOverview`,
  async (pagination: GetCommissionBenchmarkOverviewRequest, thunkAPI) => {
    try {
      const res = await CommissionBenchmarkService.getAccountsOverview(pagination)

      if (res.success) return res as CommissionBenchmarkAccountOverviewResponse

      return thunkAPI.rejectWithValue(res.message ?? 'Failed to load accounts overview')
    } catch (error) {
      return thunkAPI.rejectWithValue(error instanceof Error ? error.message : String(error))
    }
  },
)

export const GetCommissionBenchmarkAccountBreakdown = createAsyncThunk(
  `${SLICE_NAME}/getAccountBreakdown`,
  async (
    params: {
      accountId: number
      benchmarkType?: CommissionBenchmarkBenchmarkTypeEnum
      nuvestoAccountType?: CommissionBenchmarkNuvestoAccountTypeEnum
    },
    thunkAPI,
  ) => {
    try {
      const res = await CommissionBenchmarkService.getAccountBreakdown(
        params.accountId,
        undefined,
        params.nuvestoAccountType,
        params.benchmarkType,
      )

      if (res.success) {
        return {
          accountId: params.accountId,
          response: res as CommissionBenchmarkAccountBreakdownResponse,
        }
      }

      return thunkAPI.rejectWithValue(res.message ?? 'Failed to load account breakdown')
    } catch (error) {
      return thunkAPI.rejectWithValue(error instanceof Error ? error.message : String(error))
    }
  },
)
